import React from 'react';
import '../App.css';
import InfiniteScroll from 'react-infinite-scroll-component';
//import {Link} from "react-router-dom";
import { useConfig } from '../context/ConfigContext';
import { useAuth } from '../context/AuthContext.jsx';
import { useEffect, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import axios from 'axios';
import FavoriteButton from "../components/favoriteButton";
import ReactButton from "../components/reactButton";
import SketchModal from "../components/sketchModal.js"
import SketchUpload from '../components/SketchUpload.jsx';

export const Sketches = () => {
	const { user, id, role } = useAuth();
	const { backendApiBaseUrl, isTesting } = useConfig();
	const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
	const [items, setItems] = useState([]);
	const [sidebarVisible, setSidebarVisible] = useState(false);
    const [rightSideBarVisible, setRightSidebarVisible] = useState(false);
	const [selectedItem, setSelectedItem] = useState(null);
	const [hasMore, setHasMore] = useState(true);
	const [sortOrder, setSortOrder] = useState('Newest');
	const [searchParams, setSearchParams] = useSearchParams();
	const [cursor, setCursor] = useState(null);
	const [pendingFilters, setPendingFilters] = useState({
		sort: searchParams.get('sort') || 'Newest',
		minFavorites: searchParams.get('minFavorites') || '',
		maxFavorites: searchParams.get('maxFavorites') || '',
		minLikeReact: searchParams.get('minLikeReact') || '',
		maxLikeReact: searchParams.get('maxLikeReact') || '',
		minInkwell: searchParams.get('minInkwell') || '',
		maxInkwell: searchParams.get('maxInkwell') || '',
		character: searchParams.get('character') || '',
		series: searchParams.get('series') || '',
		sketcherId: searchParams.get('sketcherId') || '',
		cardCode: searchParams.get('cardCode') || '',
	});
	const [appliedFilters, setAppliedFilters] = useState(() => {
		return Object.fromEntries(
			[...searchParams.entries()].filter(([key, value]) => value !== '')
		);
	});

	const [showInfo, setShowInfo] = useState(false);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 768);
		};
	
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const handleFilterSidebarToggle = () => {
        setSidebarVisible(!sidebarVisible);
    };

    const handlerightSidebarToggle = () => {
        setRightSidebarVisible(!rightSideBarVisible);
    };

    const handleOpenModal = (item) => {
        setSelectedItem(item);
    };

    const handleCloseModal = () => {
        setSelectedItem(null);
    };

	const fetchData = useCallback(async (cursorId = null, filters = {}) => {
    	try {
			const url = new URL(`${backendApiBaseUrl}/sketches`);
			if (cursorId) {
				url.searchParams.append("cursor", cursorId);
			}

			const cleanFilters = Object.fromEntries(
				Object.entries(filters).filter(([key, value]) => value !== undefined && value !== null && value !== "")
			);

			const response = await axios.post(url.toString(), {
				filters: cleanFilters,
				userId: id,
                cursor: cursorId
			});

			const { items: rawItems, hasMore: moreAvailable, cursor: newCursor } = response.data;

			setCursor(newCursor);
			setHasMore(moreAvailable);

			const transformed = rawItems
				.filter(item => item.new_sketch !== null)
				.map(item => ({
						...item.new_sketch,
						actorUsername: item.actor?.username ?? "Unknown",
						actorId: item.actorId,
						eventId: item.id,
						type: item.targetType,
						card_code: item.new_sketch.cardCode,
						description: item.new_sketch.description || '',
						createdAt: item.createdAt,
						images: item.new_sketch.images ?? [],
						sketcher: item.new_sketch.sketcher,
						inkwell: item.new_sketch.inkwell,
						character: item.new_sketch.character,
						reactionCount: item.new_sketch._count?.reactions ?? 0,
						favoriteCount: item.new_sketch._count?.favorites ?? 0,
						userReaction: (Array.isArray(item.new_sketch.reactions) && item.new_sketch.reactions.length > 0) ? item.new_sketch.reactions[0].type : null,
						hasReacted: Array.isArray(item.new_sketch.reactions) && (item.new_sketch.reactions).length > 0,
						hasFavorited: Array.isArray(item.new_sketch.favorites) && item.new_sketch.favorites.length > 0,	
				}))

			if (cursorId) {
				setItems(prev => {
                    const updated = [...prev, ...transformed];
                    return updated;
                });
			} else {
				setItems(transformed);
			}

		} catch (err) {
			if (isTesting) {
				console.error("Failed to get sketch activity", err);
			}
		}
	}, [id, backendApiBaseUrl, isTesting]);

  	useEffect(() => {
		const sort = searchParams.get('sort') || 'Newest';
		const urlFilters = {
			sort: sort,
			minFavorites: searchParams.get("minFavorites") || '',
			maxFavorites: searchParams.get("maxFavorites") || '',
			minLikeReact: searchParams.get("minLikeReact") || '',
			minInkwell: searchParams.get('minInkwell') || '',
			maxInkwell: searchParams.get('maxInkwell') || '',
			character: searchParams.get('character') || '',
			series: searchParams.get('series') || '',
			sketcherId: searchParams.get('sketcherId') || '',
			cardCode: searchParams.get('cardCode') || '',
		}

		setSortOrder(sort);
		setPendingFilters(urlFilters);
		fetchData(null, urlFilters);
	}, [fetchData, searchParams]);

	const fetchMoreData = () => {
		if (!hasMore) {
			return;
		}

		if (cursor) {
			fetchData(cursor, appliedFilters);
		}

	};

	const handleSort = (value) => {
		setSortOrder(value);
		setPendingFilters((prev) => ({ ...prev, sort: value}));
		setSearchParams(prev => {
			const params = new URLSearchParams(prev);
			params.set("sort", value);
			return params;
		});
	};

	const handleFilterChange = (key, value) => {
		setPendingFilters(prev => ({ ...prev, [key]: value}));
	}

	const handleFilterSubmit = () => {
		const filtered = Object.fromEntries(
			Object.entries(pendingFilters).filter(([_, v]) =>{
				if (Array.isArray(v)) return v.length > 0;
				return v !== '' && v !== null && v !== undefined;
			})
		);

		const params = new URLSearchParams();

		Object.entries(filtered).forEach(([key, value]) => {
			if (Array.isArray(value)) {
				params.set(key, value.join(','));
			} else {
				params.set(key, value);
			}
		});

		setSearchParams(params);
		setAppliedFilters(filtered);

		setItems([]);
		setHasMore(true);
		setCursor(null);
	}

	useEffect(() => {
        if (appliedFilters) {
            fetchData(null, appliedFilters);
        }
    }, [appliedFilters, fetchData]);
	
	return (
		<div className='container-fluid m-0 p-0'>
			<div>
				<div className='row'>
					<aside className={`col-12 col-md-3 sidebar ${sidebarVisible ? 'd-block' : 'd-none d-md-block'} p-3 rounded`}
						style={{ 
                            maxWidth: sidebarVisible ? '100%': '215px',
                            backgroundColor: "#2b2d31",
                            transition: 'max-width 0.3 ease',
                            overflow: 'hidden',
							marginTop: '8px'
                            }}
					>
						<h4>Filters</h4>
						<div className="mb-4">
							<label className="form-label filter-title">Favorites</label>
							<div className="d-flex gap-2">
								<input type="number" className="form-control form-control-sm" placeholder="Min" min="0" value={pendingFilters.minFavorites || ''}
								onChange={(e) => handleFilterChange("minFavorites", e.target.value)} />

								<input type="number"className="form-control form-control-sm" placeholder="Max" min="0" value={pendingFilters.maxFavorites || ''}
								onChange={(e) => handleFilterChange("maxFavorites", e.target.value)} />
							</div>
						</div>

						<div className="mb-4">
							<label className="form-label filter-title">Likes / Reactions</label>
							<div className="d-flex gap-2">
								<input type="number"  className="form-control form-control-sm" placeholder="Min" min="0" value={pendingFilters.minLikeReact || ''}
								onChange={(e) => handleFilterChange("minLikeReact", e.target.value)}/>
								
								<input type="number" className="form-control form-control-sm" placeholder="Max" min="0" value={pendingFilters.maxLikeReact || ''}
								onChange={(e) => handleFilterChange("maxLikeReact", e.target.value)}/>
							</div>
						</div>

						<div className="mb-4">
							<label className="form-label filter-title">Inkwell</label>
							<div className="d-flex gap-2">
								<input type="number"  className="form-control form-control-sm" placeholder="Min" min="0" value={pendingFilters.minInkwell || ''}
								onChange={(e) => handleFilterChange("minInkwell", e.target.value)}/>
								
								<input type="number" className="form-control form-control-sm" placeholder="Max" min="0" value={pendingFilters.maxInkwell || ''}
								onChange={(e) => handleFilterChange("maxInkwell", e.target.value)}/>
							</div>
						</div>

						<div className="mb-4">
							<label className="form-label filter-title">Character</label>
							<input type="text" className="form-control form-control-sm" placeholder="Character" value={pendingFilters.character || ''}
							onChange={(e) => handleFilterChange("character", e.target.value)}/>
						</div>

						<div className="mb-4">
							<label className="form-label filter-title">Series</label>
							<input type="text" className="form-control form-control-sm" placeholder="Series" value={pendingFilters.series || ''}
							onChange={(e) => handleFilterChange("series", e.target.value)}/>
						</div>

						<div className="mb-4">
							<label className="form-label filter-title">Sketcher</label>
							<input type="number" className="form-control form-control-sm" placeholder="Sketcher" value={pendingFilters.sketcherId || ''}
							onChange={(e) => handleFilterChange("sketcherId", e.target.value)}/>
						</div>

						<div className="mb-4">
							<label className="form-label filter-title">Card Code</label>
							<input type="text" className="form-control form-control-sm" placeholder="Card Code" value={pendingFilters.cardCode || ''}
							onChange={(e) => handleFilterChange("cardCode", e.target.value)}/>
						</div>

						<button className="btn btn-primary mt-2" onClick={handleFilterSubmit}>
							Apply Filters
						</button>
					</aside>

					<div className='col-12 col-md-5' id="infiniteScrollContainer" style={{flexGrow: 1, padding: 0}}>
						<div className="d-flex justify-content-between align-items-center px-4 rounded">
							<div className='p-2'>
								<button 
									className="btn btn-secondary " 
									onClick={handleFilterSidebarToggle}
									style={{
										display: (!isMobile && !sidebarVisible) ? 'none' : 'block',
										background: '#2b2d31',
									}}>
									<i className="fa-solid fa-filter"></i>
								</button>
							</div>

							<div className='d-flex justify-content-end align-items-center'>
								<div className="p-2 ">
									<select className="form-select" value={sortOrder} style={{color:"black"}} onChange={(e) => handleSort(e.target.value)}>
										<option className='profile-filter-dropdown' value="Newest">Newest</option>
										<option className='profile-filter-dropdown' value="Oldest">Oldest</option>
									</select>
								</div>

								{user && role !== 'BAND' && (
									<div className='d-none d-sm-block'>
										<button className={`upload-button btn btn-secondary ${rightSideBarVisible ?  "d-none": "d-block"}`} onClick={handlerightSidebarToggle}
											style={{
												background: '#2b2d31',
											}}>
											Upload
										</button>
									</div>
								)}
							</div>
						</div>

						
						{items.length === 0 ? (
                            <div className="text-center mt-4" style={{  color:"#FFF" }}>
                                No items found
                            </div>
                        ) : (
							<InfiniteScroll
								dataLength={items.length}
								next={fetchMoreData}
								hasMore={hasMore}
								loader={<h4>Loading...</h4>}
								scrollableTarget="infiniteScrollContainer"
								className="itemScrollableArea"
							>
								{items.map(item => (
									<div key={item.id} className="scroll-item">
										<div className="image-container">
											{item.images.length > 0 && (
												<img
													src={item.images[0].presignedUrl}
													alt="Item Preview"
													style={{ maxWidth: '100%', paddingBottom: '10px', cursor: 'pointer' }}
													onClick={() => handleOpenModal(item)}
												/>
											)}
											<div className="card-body">
												<div>
													<h5 className="card-title">{item.title}</h5>
													<p>{item.type}</p>
												</div>
												{role !== 'BAND' &&  (
													<div style={{ display: 'flex', justifyContent: 'space-between' }}>
														<ReactButton
															itemType={item.type}
															itemId={item.id}
															userId={id}
															hasReactedInitial={item.userReaction}
															reactCountInitial={item.reactionCount}
															uniqueReactionsCount={item.uniqueReactionsCount}
															fireReactionsCount={item.fireReactionsCount}
															prettyReactionsCount={item.prettyReactionsCount}
														/>
														<FavoriteButton
															itemType={item.type}
															itemId={item.id}
															userId={id}
															hasFavoritedInitial={item.hasFavorited}
															favoriteCountInitial={item.favoriteCount}
														/>
													</div>
												)}
											</div>
										</div>
									</div>
								))}
							</InfiniteScroll>
						)}
                        <SketchModal
                            selectedItem={selectedItem}
                            show={selectedItem !== null}
                            onClose={handleCloseModal}
                        />
					</div>

                    {user && role !== 'BAND' && (
                        <aside className={`col-12 col-md-5 p-3 rounded user-sidebar ${rightSideBarVisible ? "d-block" : "d-none"}`}    
                        style={{ 
                            backgroundColor: "#2b2d31",
                            position: "relative",
                            maxWidth: rightSideBarVisible ? '300px' : '300px' }}
                        >
                            
                            <button className="btn-close" onClick={handlerightSidebarToggle} 
                                style={{ position: "absolute", top: "10px", right: "10px", transition: 'width 0.3s ease', overflow: 'hidden'}}></button>
                            <div>
								<h3>Upload Sketch</h3>

								<i
                                    className="fa-solid fa-circle-info"
                                    style={{ cursor: "pointer" }}
                                    onMouseEnter={() => setShowInfo(true)}
                                    onMouseLeave={() => setShowInfo(false)}
                                />

								{showInfo && (
									<div className="tooltip-box">
										Disclaimer*: You must own this sketch. Check about page if you don't know what images you can upload.
									</div>
								)}

								<SketchUpload 
									fetchData={fetchData} 
								/>
							</div>
                        </aside>
                    )}

				</div>
			</div>
		</div>
	);
};